import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=2268c016"
import script from "./CouponPage.vue?vue&type=script&lang=js"
export * from "./CouponPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports